module.exports = __webpack_public_path__ + "static/media/integrations.8c204edb.svg";